import React, { useEffect, useRef } from "react";
import {
  Dialog,
  DialogAction,
  DialogContent,
  DialogTitle,
  WarningBackdrop,
  WarningIcon,
} from "./styles.userAlreadyExistsDialog";

const UserAlreadyExistsDialog = ({ isMappedToOutlet = false, onClose }) => {
  const actionRef = useRef(null);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    const previouslyFocused = document.activeElement;
    actionRef.current?.focus();

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        event.stopPropagation();
        onCloseRef.current?.();
      } else if (event.key === "Tab") {
        // The dialog holds a single focusable control; keep focus inside it so
        // Tab cannot reach the obscured form behind the modal.
        event.preventDefault();
        actionRef.current?.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown, true);
    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
      if (previouslyFocused && typeof previouslyFocused.focus === "function") {
        previouslyFocused.focus();
      }
    };
  }, []);

  return (
    <WarningBackdrop>
      <Dialog
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="existing-user-dialog-title"
      >
        <DialogContent>
          <WarningIcon aria-hidden="true">
            <span>!</span>
          </WarningIcon>
          <DialogTitle id="existing-user-dialog-title">
            {isMappedToOutlet
              ? "This user is already mapped to this outlet"
              : "A user with this email or phone already exists"}
          </DialogTitle>
          <DialogAction ref={actionRef} type="button" onClick={onClose}>
            Okay
          </DialogAction>
        </DialogContent>
      </Dialog>
    </WarningBackdrop>
  );
};

export default UserAlreadyExistsDialog;
